import { processMarkdown } from '@/helpers/markdown'
import type { IAResultChunk } from '@/modules/documentSearcher/types/SearchIATypes'

/**
 * Obtiene un chunk por su ID
 * @param chunks Lista de chunks donde buscar
 * @param chunkId ID del chunk a buscar
 * @returns El chunk encontrado o undefined
 */
export const getChunkById = (chunks: IAResultChunk[] | undefined, chunkId: string): IAResultChunk | undefined => {
  if (!chunks) return undefined
  return chunks.find((chunk: IAResultChunk) => chunk.chunk_id === chunkId)
}

/**
 * Genera HTML para mostrar un chunk en un tooltip
 * @param chunk Chunk para generar el tooltip
 * @returns HTML formateado para el tooltip
 */
export const getChunkTooltipHTML = (chunk: IAResultChunk): string => {
  if (!chunk) return ''

  const sanitizedContent = processMarkdown(chunk.chunk || '', {
    limit: 10000,
    sanitizeOptions: {}
  })

  return `
    <div class="chunk-tooltip">
      <div class="chunk-content">${sanitizedContent}
      </div>
      <div class="document-button-container">
        <button class="go-to-document" data-chunk-id="${chunk.chunk_id}">Ir al documento</button>
      </div>
    </div>
  `
}
